// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"760":"1a03c3f2","787":"cd32c30d"}[chunkId] + ".chunk.js";
};